// Exchange icons mapping
import binance from './binance.ico';
import bybit from './bybit.ico';
import mexc from './mexc.ico';
import lbank from './lbank.png';
import bitmart from './bitmart.ico';
import bitget from './bitget.png';
import coinbase from './coinbase.png';
import bingx from './bingx.ico';
import coinex from './coinex.ico';
import htx from './htx.ico';
import xt from './xt.ico';
import kucoin from './kucoin.png';
import okx from './okx.png';
import kraken from './kraken.ico';

// Map exchange names to their icons
export const exchangeIcons = {
  'Binance': binance,
  'Bybit': bybit,
  'Mexc': mexc,
  'MEXC': mexc,
  'LBank': lbank,
  'Bitmart': bitmart,
  'Bitget': bitget,
  'Coinbase': coinbase,
  'Bingx': bingx,
  'BingX': bingx,
  'Coinex': coinex,
  'CoinEx': coinex,
  'Htx': htx,
  'HTX': htx,
  'XT': xt,
  'Kucoin': kucoin,
  'KuCoin': kucoin,
  'OKX': okx,
  'Okx': okx,
  'Kraken': kraken
};

// Helper function to get exchange icon
export const getExchangeIcon = (exchangeName) => {
  if (!exchangeName) return null;
  return exchangeIcons[exchangeName] || null;
};
